export const NATURE_OF_BUSINESS_OPTIONS = [
  'IT / Software',
  'Manufacturing',
  'Healthcare',
  'Education',
  'Retail / E-commerce',
  'Finance / Banking',
  'Hospitality / Tourism',
  'Logistics / Supply Chain',
  'Real Estate / Construction',
  'Media / Entertainment',
  'Automotive',
  'Telecommunications',
  'Agriculture',
  'Consulting / Professional Services',
  'Other'
];
